import { useCallback, useRef } from "react";

export function useRouteHeadingFocus<T extends HTMLElement>(focusKey: string) {
  const lastFocusedKeyRef = useRef<string | null>(null);

  return useCallback(
    (element: T | null) => {
      if (!element || lastFocusedKeyRef.current === focusKey) {
        return;
      }

      lastFocusedKeyRef.current = focusKey;
      requestAnimationFrame(() => {
        if (element.isConnected) {
          element.focus({ preventScroll: true });
        }
      });
    },
    [focusKey],
  );
}
